import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import { DivisionId, SenderId, ClientId, PrevilageId } from "../../helper/HelperAuth";
import DatePickerInput from "../../infra/components/formInput/DatePickerInput";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import ActionDownload from "../../store/action/CheckContact/Download"
import ActionGetCheckContact from '../../store/action/CheckContact/Fetch'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import { IsCreate } from '../../store/constants'
import ActionGetAccessModule from '../../store/action/AccessModule/Fetch'
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import { Modal } from 'react-bootstrap';

class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: "Check Contact",
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            }),
            isadmin:false,
            action_id: this.handleActionId(),
            searchForm: fromJS({
                "client-id": '',
                "division-id": '',
                "sender-id": '',
                "start-date": "",
                "end-date": ""
            }),
            columns: [
                { className: "col-sm-1", cfield: "counter", caption: "No" },
                { className: "col-sm-2", field: "client-name", caption: "Client Name", allowSearch: true },
                { className: "col-sm-1", field: "division-name", caption: "Division", allowSearch: true },
                { className: "col-sm-1", field: "sender", caption: "Sender", allowSearch: true },
                { className: "col-sm-2", field: "createdAt", caption: "Date Uploaded", allowSearch: true },
                { className: "col-sm-2", field: "filename", caption: "File Name", allowSearch: true },
                { className: "col-sm-1", field: "status", caption: "Status", allowSearch: true },
                {  
                    cfield: "action", caption: "Detail", className: "col-sm-2", allowView: false, allowEdit: false, allowDelete: false,
                    custom : fromJS([
                        { "id": "Split", "icon": "visibility", "label": "Open", "className": "btn btn-success btn-sm" },
                    ])
                },
            ],
            errors: fromJS({}),
            disrest: true,
            modalShow: false,
            modalData: fromJS({})
        };

        this.showContent = this.showContent.bind(this);
        this.handleFindSearch = this.handleFindSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleCustomAction = this.handleCustomAction.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    async componentDidMount() {
        let formVal = this.state.searchForm
        await this.props.actionGetAccessModule(PrevilageId);
        var isAdmin = await this.props.actionFindByGroupId()
        this.setState({isadmin:isAdmin})
        let restrict = this.handleActionId()
        this.props.actionGetAllClient()
        console.log(restrict)
        if (restrict == 5) {
            await this.props.actionGetAllDivision(ClientId, 'Check Contact')
            this.props.actionGetAllSender(ClientId)
            formVal = formVal.set("client-id", ClientId)
            formVal = formVal.set("division-id", DivisionId)
            formVal = formVal.set("sender-id", SenderId)
            this.setState({
                searchForm: formVal,
                disrest: true
            })
        } else {
            this.setState({
                disrest: false
            })
        }

    }

    handleActionId() {
        let array = []
        let action = 0;
        let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
        {
            menuPrev.map((data, i) =>
                array.push({
                    'menu-name': data.get('menu-name'),
                    'action-id': data.get('action-id')
                })

            )
        }

        for (let i = 0; i < array.length; i++) {
            if (array[i]['menu-name'] === 'Check Contact') {
                action = array[i]['action-id'];
                this.state.action_id = array[i]['action-id'];
            }
        }
        return action;
    }

    handleOnBindCustomAction(actionId, row) {
        if(actionId === 'Split' || actionId === 'HoverCheckContact') {
            return true;
        }
        return false;
    }

    async handleCustomAction(id, row) {
        switch (id) {
            case "DownloadValid":
                var result1 = await this.props.actionDownload(row.get('job-id'), "valid", row.get('filenameValid'))
                //debugger;
                if (!result1.ok) {
                    toast.error("Download Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            case "DownloadInvalid":
                var result1 = await this.props.actionDownload(row.get('job-id'), "invalid", row.get('filenameInValid'))
                //debugger;
                if (!result1.ok) {
                    toast.error("Download Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            case "DownloadTotal":
                var result1 = await this.props.actionDownload(row.get('job-id'), "upload", row.get('filename'))
                //debugger;
                if (!result1.ok) {
                    toast.error("Download Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            case "Split":
                this.setState({modalShow: true, modalData: row});
                break;
            default:
        }
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        console.log(field,value)
        formVal = formVal.set(field, value);
        if (field === 'client-id') {
            formVal = formVal.set('sender-id', '')
            formVal = formVal.set('division-id', '')
            this.setState({ client_id: value })
            this.props.actionGetAllDivision(value);
            this.props.actionGetAllSender(value);
        }

        if (field === 'division-id') {
            formVal = formVal.set('sender-id', '')
            this.setState({ searchForm: formVal })
         
        }
        console.log(field)
        this.setState({ searchForm: formVal })

    }

    handleCancelForm(refresh) {
        if (refresh) {
            this.handleFindSearch(1);
        }
        this.setState({
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew() {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    handleCloseModal() {
        this.setState({modalShow: false});
    }

    handleFindSearch(page) {
        const { searchForm } = this.state;
        let sender_id = searchForm.get('sender-id');
        let client_id = searchForm.get('client-id');
        let division_id = searchForm.get('division-id');
        let sender = [];
        var bodyFInd = {};
        let res = null;
        var isAdmin = this.state.isadmin
        
        if (client_id === "" || client_id === "null" || client_id === null) client_id = 0;
        if (division_id === "" || division_id === "null" || division_id === null) division_id = 0;

        if ((sender_id === "" || sender_id == undefined
            || sender_id === " " || sender_id === null
            || sender_id === "null" || sender_id === [""]) && client_id != 0) {
             if (PrevilageId != 1 && isAdmin == false) {
            client_id = ClientId;
            division_id = DivisionId;
            }
            this.props.actionGetAllSender(client_id, division_id)

            setTimeout(() => {
                res = this.props.senderall;
                if (res.size > 0) {
                    sender = [];
                }

                {
                    res.map((data, i) =>
                        sender.push(data.get('sender-id'))
                    )
                }
                if(sender[0] == '') sender = []
                bodyFInd = {
                    "client-id": client_id,
                    "division-id": division_id,
                    "sender-id": sender,
                    "start-date": searchForm.get("start-date"),
                    "end-date": searchForm.get("end-date")
                }
                this.props.actionGet(page, bodyFInd);

            }, 3000);

        } else {
            if (PrevilageId != 1 && isAdmin == false) {
                client_id = ClientId;
                division_id = DivisionId;
                if (this.state.actionId != 5) {

                    this.props.actionGetAllSender(client_id, division_id)
                } setTimeout(() => {
                    res = this.props.senderall;
                    if (res.size > 0) {
                        sender = [];
                    }
                    {
                        res.map((data, i) =>
                            sender.push(data.get('sender-id'))
                        )
                    }

                    if (sender_id != "") sender = [sender_id]
                    if (sender[0] == '') sender = []
                    bodyFInd = {
                        "client-id": client_id,
                        "division-id": division_id,
                        "sender-id": sender,
                        "start-date": searchForm.get("start-date"),
                        "end-date": searchForm.get("end-date")
                    }
                    this.props.actionGet(page, bodyFInd);
                }, 3000);
            } else {
                sender = [];
                sender.push(sender_id)
                if (sender[0] == '') sender = []
                bodyFInd = {
                    "client-id": client_id,
                    "division-id": division_id,
                    "sender-id": sender,
                    "start-date": searchForm.get("start-date"),
                    "end-date": searchForm.get("end-date")
                }
                this.props.actionGet(page, bodyFInd);
            }
        }
    }

    refreshGrid(page, search) {
        this.handleFindSearch(page)
    }

    handleFind() {
        this.handleFindSearch(1)
    }

    showContent() {
        var form = this.state.form;

        if (form.get('show')) {
            return (
                <Form
                    actionType={form.get('actionType')}
                    item={form.get('item')}
                    handleCancelForm={this.handleCancelForm}
                    handleSubmitOnForm={this.handleSubmitOnForm}
                >
                </Form>
            )
        } else {
            const items = this.props.checkcontact ? fromJS(this.props.checkcontact) : fromJS({});
            const modalData = this.state.modalData;

            return (
                <div>
                    <CustomGrid
                        title="Check Contact"
                        columns={this.state.columns}
                        items={items}
                        handleOnBindCustomAction={this.handleOnBindCustomAction}
                        handleCustomAction={this.handleCustomAction}
                        handlePageChanged={this.handlePageChanged}
                    >
                    </CustomGrid>

                    {/* Modal Detail Report */}
                    <Modal show={this.state.modalShow} onHide={this.handleCloseModal} dialogClassName="modal-small">
                        <Modal.Header closeButton>
                            <Modal.Title>Detail MSISDN Validation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <table className="table table-responsive-sm">
                                <tbody>
                                    <tr>
                                        <td>Valid MSISDN</td>
                                        <td> : </td>
                                        <td>{modalData.get('totalValid')}</td>
                                        <td>
                                            {
                                                modalData.get('filenameValid') ? (
                                                    <button title="Download Valid" className={`btn-trans btn-sm waves-effect text-success`} onClick={() => this.handleCustomAction("DownloadValid", modalData)} >
                                                        <i className="material-icons" title="Download Valid">cloud_download</i> 
                                                    </button>
                                                ):null
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Invalid MSISDN</td>
                                        <td> : </td>
                                        <td>{modalData.get('totalInvalid')}</td>
                                        <td>
                                            {
                                                modalData.get('filenameInValid') ? (
                                                    <button title="Download Invalid" className={`btn-trans btn-sm waves-effect text-success`} onClick={() => this.handleCustomAction("DownloadInvalid", modalData)} >
                                                        <i className="material-icons" title="Download Invalid">cloud_download</i> 
                                                    </button>
                                                ):null
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Total MSISDN</td>
                                        <td> : </td>
                                        <td>{modalData.get('totalMsisdn')}</td>
                                        <td>
                                            {
                                                modalData.get('filename') ? (
                                                    <button title="Download Total" className={`btn-trans btn-sm waves-effect text-success`} onClick={() => this.handleCustomAction("DownloadTotal", modalData)} >
                                                        <i className="material-icons" title="Download Total">cloud_download</i> 
                                                    </button>
                                                ):null
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button"
                                className="btn btn-wide btn-danger"
                                onClick={this.handleCloseModal}>
                                Close
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            )
        }
    }

    render() {
        const { searchForm, form } = this.state;
        const title = form.get('show') ? "Upload Check Contact" : "Check Contact";
        const classHide = title == 'Check Contact' ? 'card' : 'card hidden'
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                <div className={classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Client"
                                    disabled={this.state.disrest}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Division"
                                    disabled={this.state.disrest}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Sender"
                                    disabled={this.state.disrest}
                                />
                            </div>
                            <div className="col-sm-6">
                                <span className="col-sm-1">Start</span>
                                <div className="col-sm-4">
                                    <DatePickerInput
                                        dateFormat="yyyy-MM-dd"
                                        convertvalue
                                        field="start-date"
                                        value={searchForm.get('start-date')}
                                        onChange={(field, date) => this.handleChange(field, date)}
                                    />
                                </div>
                                <span className="col-sm-1">End</span>
                                <div className="col-sm-4">
                                    <DatePickerInput
                                        convertvalue
                                        dateFormat="yyyy-MM-dd"
                                        field="end-date"
                                        value={searchForm.get('end-date')}
                                        onChange={(field, date) => this.handleChange(field, date)}
                                        minDate={new Date(searchForm.get('start-date'))}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success content-add"
                                    onClick={this.handleNew}>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            accessmodules: state.user.accessmodules,
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
            checkcontact: state.user.checkcontacts
        }
    },
    dispatch => bindActionCreators({
        actionGetAllClient: ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionGet: ActionGetCheckContact,
        actionGetAccessModule: ActionGetAccessModule,
        actionDownload: ActionDownload,
        actionFindByGroupId:ActionFindByGroupId
    }, dispatch),
)(Page);